import React from 'react';
import classNames from 'classnames';

import Button from '../Button';

import styles from './PaymentPlan.module.scss';

const {
  'payment-plan': paymentPlanClass,
  title: titleClass,
  'monthly-price': monthlyPriceClass,
  'single-payment-price': singlePaymentPriceClass,
  'year-option': yearOptionClass,
  'month-selector-container': monthSelectorContainerClass,
  'month-selector': monthSelectorClass,
  'price-copy': pricingCircleCopyClass,
  'price-dollars': priceCircleDollars,
  'price-cents': priceCircleCents,
  selected: selectedYearClass,
  'one-payment-button': onePayment,
  'monthly-pay-button': monthlyPayment
} = styles;

const PaymentPlan = ({
  defaultPackageName,
  handlePlanChange,
  handleSelectPlan,
  monthlyOptions,
  selectedPlanIdx,
  singlePaymentIdx,
  submitButtonCopy,
  displayDollars,
  displayCents,
  isSinglePaymentSelected
}) => {
  const monthSelector = () => {
    return monthlyOptions.map(({ years }, idx) => {
      const selectedYear = classNames({
        [selectedYearClass]: selectedPlanIdx === idx
      });
      return (
        <div
          className={`${yearOptionClass} ${selectedYear}`}
          onClick={() => handlePlanChange(idx)}
          key={`${idx}_${years}`}
        >{`${years} Years`}</div>
      );
    });
  };

  const monthlyPriceClasses = classNames(monthlyPriceClass, {
    [singlePaymentPriceClass]: isSinglePaymentSelected
  });

  return (
    <div className={paymentPlanClass}>
      <div className={titleClass}>
        Your price estimate for the {defaultPackageName || 'package'}
      </div>
      <div className={monthlyPriceClasses}>
        <div className={priceCircleDollars}>{`$${displayDollars}`}</div>
        {!isSinglePaymentSelected && <div className={pricingCircleCopyClass}>{'Per Month'}</div>}
        <div className={priceCircleCents}>{`.${displayCents}`}</div>
      </div>
      <div className={monthSelectorContainerClass}>
        <p>Payments over</p>
        <div className={monthSelectorClass}>{monthSelector()}</div>
      </div>
      <Button
        border="border-white"
        clickAction={() => handlePlanChange(singlePaymentIdx)}
        copy="Or, pay 1 payment"
        color="white"
        width="full"
        customClass={onePayment}
      />
      <Button
        clickAction={handleSelectPlan}
        copy={submitButtonCopy}
        width="full"
        customClass={monthlyPayment}
      />
    </div>
  );
};

export default PaymentPlan;
